import { Navbar, Nav, Container, NavDropdown, Badge } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';

import logo from '../assets/logo.png';
import { resetCart } from '../slices/cartSlice';

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth); // isAdmin and isStaff flags come from backend

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate('/login');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <header>
      <Navbar bg='primary' variant='dark' expand='lg' collapseOnSelect>
        <Container>
          <Navbar.Brand as={Link} to='/'>
            <img src={logo} alt='P' />harmacy
          </Navbar.Brand>
          
          <Navbar.Brand as={Link} to='/salesform'>SalesForm</Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto'>
              
              <Nav.Link as={Link} to='/cart'>
                <FaShoppingCart /> Cart
                {cartItems.length > 0 && (
                  <Badge pill bg='success' style={{ marginLeft: '5px' }}>
                    {cartItems.reduce((a, c) => a + c.qty, 0)}
                  </Badge>
                )}
              </Nav.Link>

              {/* Authenticated User */}
              {userInfo ? (
                <>
                  {/* User Dropdown */}
                  <NavDropdown title={userInfo.name} id='username'>
                    <NavDropdown.Item as={Link} to='/profile'>Profile</NavDropdown.Item>
                    <NavDropdown.Item onClick={logoutHandler}>Logout</NavDropdown.Item>
                  </NavDropdown>

                  {/* Admin Links */}
                  {userInfo.isAdmin && ( // Check if isAdmin is true
                    <NavDropdown title='Admin' id='adminmenu'>
                      <NavDropdown.Item as={Link} to='/cartform'>Forms</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/adminform'>AdminPages</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/Storeadmin/storeAdminForm'>MiniAdminP</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/storeCartform'>MiniForms</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/salelist'>Sales</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/purchaselist'>Purchases</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/notelist'>AdminNote</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/minutes'>Minutes</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/startstockscreen'>Cost Overview</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/workingcapital'>Working Capital</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockanalysis'>StockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/dailystocklist'>DailyStock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/dailystockanalysis'>DailyStockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balance'>CashAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balancebyuser'>Sum By User</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/reportstockscreen'>Stock Overview</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/userlist'>Users</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stockuniquedates'>StockDates</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/houselist'>Houses</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/dailystockuniquedates'>DailyStockDates</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/productlist'>Itemlist</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/expenselist'>Nafulo</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/admin/adminuserprofile'>ResetPassword</NavDropdown.Item>
                      
                      
                    </NavDropdown>
                  )}

                  {/* Staff Links */}
                  {userInfo.isStaff && ( // Check if isStaff is true
                    <NavDropdown title='Staff' id='staffmenu'>
                      <NavDropdown.Item as={Link} to='/productlist'>ItemList</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/cartform'>Forms&Pages</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/storeCartform'>MiniForms&Pages</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffsale'>Sales</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffsupply'>Supplies</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/expenselist'>Income/Expense</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/cashlist'>CashCollected</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balancebyuserscreen'>Sum By User</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balancebycustomerscreen'>Sum By Customer</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/balancescreen'>CashAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffdailystock'>DailyStock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/dailystockreport'>DailyStockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/productlist'>ItemList</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/customeruserlist'>CustomerList</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/stafftransfer'>Transfers</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffstock'>Stock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/itemsneeded'>StockAnalysis</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffinsurance'>Insu Bills</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffopeningstock'>OP Stock</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/dailystockuniquedates'>DailyStockDates</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to='/staffnote'>Notes</NavDropdown.Item>
                      
                      <NavDropdown.Item as={Link} to='/stockuniquedates'>StockDates</NavDropdown.Item>
                      {/* Add more staff-specific links as needed */}
                    </NavDropdown>
                  )}
                </>
              ) : (
                <Nav.Link as={Link} to='/login'>
                  <FaUser /> Sign In
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;